import React, { Component } from 'react'
import '../css/containers/App.scss'
import Status from '../components/Status'
import PeriodToggle from '../components/PeriodToggle'
import SpeedChartContainer from './SpeedChartContainer'
import BzChartContainer from './BzChartContainer'
import DensityChartContainer from './DensityChartContainer'
import GeoMagContainer from './GeoMagContainer'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import FAButton from '../components/FAButton'
import KIndexChartContainer from './KIndexChartContainer'
import MagChangeContainer from './MagChangeContainer'
import {
  SPEED_THRESHOLDS,
  BZ_THRESHOLDS,
  DENSITY_THRESHOLDS,
  KPI_THRESHOLDS,
} from '../constants/thresholds'
import { connect } from 'react-redux'
import { update } from '../actions'

interface AppProps {
  dispatch: any
  period: any
  speedLoading: any
  bZLoading: any
  speed: any
  bZ: any
  density: any
  kIndex: any
}

class App extends Component<AppProps> {
  constructor(props: any) {
    super(props)
    this.update = this.update.bind(this)
  }

  update() {
    this.props.dispatch(update(this.props.period))
  }

  render() {
    const { speedLoading, bZLoading } = this.props
    const { speed, bZ, density, kIndex } = this.props
    const loading = Boolean(speedLoading && bZLoading)

    return (
      <div className="App">
        <Header loading={loading} />

        <div className="status-wrapper">
          <Status
            title="Latest speed"
            error={speed.error}
            fetching={speed.fetching}
            {...speed.latest}
            unit="km/s"
            thresholds={SPEED_THRESHOLDS}
          />
          <Status
            title="Field bZ"
            fetching={bZ.fetching}
            error={bZ.error}
            {...bZ.latest}
            thresholds={BZ_THRESHOLDS}
            unit="nT"
            reverseThresholds={true}
          />
          <Status
            title="Density"
            fetching={density.fetching}
            error={density.error}
            {...density.latest}
            thresholds={DENSITY_THRESHOLDS}
          />
          <Status
            title="K-Index"
            fetching={kIndex.fetching}
            error={kIndex.error}
            {...kIndex.latest}
            thresholds={KPI_THRESHOLDS}
          />
        </div>

        <div className="status-wrapper">

          <MagChangeContainer />

        </div>

        <div className="divider" />

        <PeriodToggle />

        <SpeedChartContainer />

        <BzChartContainer />

        <DensityChartContainer />

        <GeoMagContainer />

        <KIndexChartContainer />

        <FAButton action={this.update} />

        <Footer />
      </div>
    )
  }
}

function mapStateToProps(state: any) {
  return {
    kIndex: state.kIndex,
    density: state.density,
    speed: state.speed,
    bZ: state.bZ,
    speedLoading: state.speed.fetching,
    bZLoading: state.bZ.fetching,
    period: state.period,
  }
}

export default connect(mapStateToProps)(App)
